(() => {
  if (customElements.get('fyid-system-selector')) return;
  class FyidSystemSelector extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.button = this.querySelector('[type=submit]');
      this.error = this.querySelector('[role=alert]');
      this.addEventListener('change', () => this.update());
      this.addEventListener('input', () => this.update());
      this.form.addEventListener('submit', event => this.submit(event));
      this.update();
    }
    selections() { return [...this.querySelectorAll('input[data-component]:checked')]; }
    quantity() { return Number(this.querySelector('[data-system-quantity]').value); }
    update() {
      const qty = this.quantity();
      const selected = this.selections();
      const valid = Number.isInteger(qty) && qty >= 1 && qty <= 99 && selected.length > 0 && selected.every(input => input.dataset.available === 'true');
      this.button.disabled = Boolean(this.busy) || !valid;
      const cents = selected.reduce((sum, input) => sum + Number(input.dataset.price), 0) * (valid ? qty : 1);
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency}).format(cents / 100);
      this.querySelector('[data-system-total]').textContent = money;
      const main = this.closest('.product__info-container');
      if (main) main.querySelectorAll('[data-fyid-system-price]').forEach(el => el.textContent = money);
    }
    async submit(event) {
      event.preventDefault();
      if (this.button.disabled || this.busy) return;
      this.busy = true; this.button.disabled = true; this.error.textContent = '';
      const items = this.selections().map(input => ({id:Number(input.value),quantity:this.quantity(),properties:{'System':this.dataset.spu}}));
      const root = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || this.dataset.error);
        if (!Array.isArray(result.items) || result.items.length !== items.length) throw new Error(this.dataset.error);
        window.location.assign(root + 'cart');
      } catch (error) {
        this.error.textContent = error.message || this.dataset.error;
      } finally { this.busy = false; this.update(); }
    }
  }
  customElements.define('fyid-system-selector', FyidSystemSelector);
})();
